import React, { memo, PropsWithChildren } from "react";
import { withStyles } from "@material-ui/core";
import style from "pages/flyer/flyerTypePage/components/LinkToFile/style";
import { TemplatePendingNote } from "pages/flyer/builder/formats/TemplatePendingNote";
import { ReactComponent as DownloadIcon } from "static/media/download.svg";

type IProps = PropsWithChildren<{
  classes: any;
  href: string;
  linkText: string;
  icon?: boolean;
  cypressId?: string;
  // When the file is not generated yet (empty href), show a note instead of a dead link.
  pendingNote?: boolean;
  onClick?: () => void;
}>;

const LinkToFile: React.FC<IProps> = ({
  classes,
  href,
  linkText,
  cypressId,
  icon = false,
  pendingNote = false,
  children = undefined,
  onClick = () => {},
}) => {
  if (!href && pendingNote) {
    return <TemplatePendingNote cypressId={cypressId ? `${cypressId}Pending` : undefined} />;
  }

  return (
    <span className={classes.inlineBlock}>
      <a
        className={classes.link}
        href={href}
        rel="noreferrer"
        target="_blank" // @ts-ignore
        cypress_id={cypressId}
        onClick={onClick}
      >
        {icon ? <DownloadIcon></DownloadIcon> : null}
        {linkText}
        {children}
      </a>
    </span>
  );
};

export default memo(withStyles(style)(LinkToFile));
